import React from 'react';
import styles from './style/listCell.module.css';

interface ListCellProps {
  label: string,
  responsive?: string | number,
  value: string | number,
}

const ListCell = ({ label, responsive, value }: ListCellProps) => (
  <div className={`${styles.listCell} ${responsive ? styles[`listCell_responsive${responsive}`] : ''}`}>
    <span className="small-print">{ label }</span>
    <strong>{ value }</strong>
  </div>
);

ListCell.defaultProps = {
  responsive: '',
}

export default ListCell;
